import styled from "styled-components";

import { Select } from "shared/ui";
import { colors } from "shared/ui/tokens";

import { MOBILE_BREAKPOINT } from "features/IikoIntegration/constants";

// Селект и «Добавить» в шапке карточки; на телефоне разворачиваются в колонку на всю ширину.
export const AddTerminal = styled.div`
    display: flex;
    gap: 8px;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        flex-direction: column;

        button {
            width: 100%;
        }
    }
`;

/*
* Ширина селекта — раскладка, поэтому живёт в стилях фичи. Через `styled(Select)`, а не
* селектором по элементу: селект кита рисуется кнопкой, и правило по `select` перестало
* попадать в цель (а `button` в этом ряду два — селект и «Добавить»).
* */
export const TerminalSelect = styled(Select)`
    min-width: 260px;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        min-width: 0;
    }
`;

export const Identifier = styled.span`
    font-family: ui-monospace, Menlo, monospace;
`;

export const TerminalDot = styled.span`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${colors.success};
    display: block;
`;

export const WideAction = styled.div`
    display: flex;
    justify-content: flex-end;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        display: none;
    }
`;

export const CompactAction = styled.div`
    display: none;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        display: flex;
        justify-content: flex-end;
    }
`;
